import forEach from '../../../../javascripts/dom/forEach';

const contactFilters = document.querySelectorAll('[data-js-module="o-contact-filter"]');

const init = async () => {
  const { default: ContactFilter } = await import(
    /* webpackChunkName: "m-contact-filter" */ './contact-filter'
  );
  forEach(contactFilters, (index, element) => new ContactFilter(element));
};

if (contactFilters.length) init();
